var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4062 12.0005C19.4062 9.46343 21.4629 7.40674 23.9999 7.40674C26.537 7.40674 28.5937 9.46343 28.5937 12.0005V14.0004H19.4062V12.0005ZM16.5937 14.0004V12.0005C16.5937 7.91013 19.9096 4.59424 23.9999 4.59424C28.0903 4.59424 31.4062 7.91013 31.4062 12.0005V14.0004H35.9999L37.9999 40.0004H9.99994L11.9999 14.0004H16.5937Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.92cb572237c4ffcc5737a28eb1ee4390.svg";
export { ForwardRef as ReactComponent };